import {
    Box,
    Grid,
    GridItem,
    Image,
    List,
    ListIcon,
    ListItem,
    Text
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import {
    MdCheckCircle,
    MdDateRange,
    MdSettings,
    MdTimer
} from "react-icons/md";
import { useParams } from "react-router-dom";
import { AccountAvatar } from "../../components/AccountAvatar";
import { Loader } from "../../components/Loader";
import { Title } from "../../components/Title";
import { useGetEventQuery } from "../../graphql";
import { useDashboardTitle } from "../../hooks/useDashboardTitle";
import { formatDateTime } from "../../utils";

const Event: React.FC = () => {
    const { t } = useTranslation();
    const { setTitle } = useDashboardTitle();
    const { id } = useParams();

    const { data, loading } = useGetEventQuery({
        variables: {
            id: parseInt(id)
        }
    });
    const event = data?.getEvent;

    useEffect(() => {
        if (!loading) {
            setTitle([
                {
                    to: "/events",
                    text: "Evente"
                },
                event.title
            ]);
        }

    // eslint-disable-next-line
  }, [loading]);

    return (
        <>
            { loading ? (
                <Loader />
            ) : (
                <Grid templateColumns="repeat(3, 1fr)" gap={ 6 }>
                    <GridItem
                        borderWidth="1px"
                        borderRadius="lg"
                        overflow="hidden"
                        p={ 2 }
                        background="white"
                        colSpan={ 2 }
                    >
                        <Title title={ event.title }></Title>

                        <Box borderWidth="1px" borderRadius="lg" overflow="hidden">
                            <Image
                                src={ event.cover.url }
                                style={ { objectFit: "cover", width: "100%" } }
                            />
                        </Box>

                        <List spacing={ 3 } m={ 5 }>
                            <ListItem>
                                <Text
                                    fontSize="xs"
                                    textTransform="uppercase"
                                    fontWeight="bold"
                                    color="grey"
                                    paddingBottom="5px"
                                >
                                    { t("events.organiser") }
                                </Text>
                                <AccountAvatar account={ event.specialist } />
                            </ListItem>
                            <ListItem>
                                <ListIcon as={ MdDateRange } color="blue.500" />
                                { t("events.date") }: { formatDateTime(event.startDate) }
                            </ListItem>
                            <ListItem>
                                <ListIcon as={ MdTimer } color="blue.500" />
                                { t("events.duration") }: { event.durationMinutes }{ " " }
                                { t("events.minutes") }
                            </ListItem>
                        </List>

                        <Text>{ event.description }</Text>
                    </GridItem>
                    <GridItem
                        borderWidth="1px"
                        borderRadius="lg"
                        overflow="hidden"
                        p={ 2 }
                        background="white"
                        colSpan={ 1 }
                    >
                        <Title
                            title={ `${t("events.participants")} (${
                                event.participants.list.length
                            } / ${event.participants.maxNumber})` }
                        ></Title>
                        { !event.participants.list.length && t("events.noParticipants") }
                        { event.participants.list.map((participant) => (
                            <AccountAvatar account={ participant } size="sm" role={ false } />
                        )) }
                    </GridItem>
                </Grid>
            ) }
        </>
    );
};

export default Event;
